import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createSlots as _createSlots, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "editable-cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_SchemaFormItem = _resolveComponent("SchemaFormItem")!
  const _component_CheckOutlined = _resolveComponent("CheckOutlined")!
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_EditOutlined = _resolveComponent("EditOutlined")!
  const _component_Spin = _resolveComponent("Spin")!

  return (_openBlock(), _createBlock(_component_Spin, { spinning: _ctx.saving }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Popover, {
          open: !!_ctx.errorMsgs?.length,
          placement: "topRight"
        }, {
          content: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorMsgs, (err) => {
              return (_openBlock(), _createBlock(_component_a_typography_text, {
                key: err,
                type: "danger"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(err), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_row, {
              type: "flex",
              gutter: [8]
            }, {
              default: _withCtx(() => [
                ((_ctx.getIsEditable || _ctx.getIsCellEdit) && _ctx.getSchema)
                  ? (_openBlock(), _createBlock(_component_SchemaFormItem, {
                      key: 0,
                      "form-model": _ctx.editFormModel,
                      "onUpdate:formModel": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editFormModel) = $event)),
                      schema: _ctx.getSchema,
                      "table-instance": _ctx.tableContext,
                      "table-row-key": _ctx.rowKey
                    }, _createSlots({ _: 2 }, [
                      _renderList(Object.keys(_ctx.$slots), (item) => {
                        return {
                          name: item,
                          fn: _withCtx((data) => [
                            _renderSlot(_ctx.$slots, item, _normalizeProps(_guardReactiveProps(data || {})), undefined, true)
                          ])
                        }
                      })
                    ]), 1032, ["form-model", "schema", "table-instance", "table-row-key"]))
                  : _createCommentVNode("", true),
                (_ctx.getIsCellEdit)
                  ? (_openBlock(), _createBlock(_component_a_col, {
                      key: 1,
                      span: 4,
                      class: "flex items-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CheckOutlined, { onClick: _ctx.handleSaveCell }, null, 8, ["onClick"]),
                        _createVNode(_component_CloseOutlined, { onClick: _ctx.handleCancelSaveCell }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 8, ["open"]),
        (!_ctx.isCellEdit && _ctx.editableType === 'cell')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true),
              _createVNode(_component_EditOutlined, { onClick: _ctx.startEditCell }, null, 8, ["onClick"])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }, 8, ["spinning"]))
}